import type { QueryClient } from "@tanstack/react-query";
import type { BackendModule, ReadCallback } from "i18next";

/**
 * Os bundles de tradução são módulos JSON locais (Vite bundle, não vêm do backend Nest),
 * mas o fetch/cache de cada namespace ainda passa pelo TanStack Query — mesmo cache/dedupe
 * usado pro resto dos dados da aplicação, e só carrega o namespace quando uma rota o pede.
 */
const localeModules = import.meta.glob<{ default: Record<string, unknown> }>("./locales/**/*.json");

function resolveLoader(language: string, namespace: string) {
  const key = `./locales/${language}/${namespace}.json`;
  return localeModules[key];
}

export function createQueryI18nBackend(queryClient: QueryClient): BackendModule {
  return {
    type: "backend",
    init() {},
    read(language: string, namespace: string, callback: ReadCallback) {
      const loader = resolveLoader(language, namespace);
      if (!loader) {
        callback(new Error(`Missing translation bundle: ${language}/${namespace}`), null);
        return;
      }

      queryClient
        .fetchQuery({
          queryKey: ["i18n-bundle", language, namespace],
          queryFn: async () => (await loader()).default,
          staleTime: Infinity,
        })
        .then((resources) => callback(null, resources))
        .catch((error) => callback(error, null));
    },
  };
}
